<div class="profile-container">
  <h1>Perfil do usuário</h1>
  <app-user-form #userForm mode="edit"></app-user-form>
  <button mat-raised-button color="primary" (click)="onSave()">Salvar</button>
  
</div>

